<script setup lang="ts">
type SrcSetEntry = { src: string, viewportWidth: string }

defineProps<{
  srcSetArray: SrcSetEntry[],
  fallbackPlaceholderSource?: string,
  loading: 'lazy' | 'eager',
  fetchPriority?: 'high',
  altText: string
}>()

function setMediaQuery (viewport: number | string) {
  return '(max-width: ' + viewport + 'px)'
}
</script>

<template>
  <picture>
    <source v-for="(singleSrc, index) in srcSetArray"
            :key="index + 'webp'"
            type="image/webp"
            :loading="loading"
            :media="setMediaQuery(singleSrc.viewportWidth)"
            :srcset="singleSrc.src">
    <img :src="fallbackPlaceholderSource"
         data-pin-nopin="true"
         :loading="loading"
         :fetchpriority="fetchPriority"
         width="1600"
         height="900"
         :alt="altText"
         :title="altText">
  </picture>
</template>
